/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Transcript text if job is completed
 * @export
 * @interface Transcript
 */
export interface Transcript {
}

/**
 * Check if a given object implements the Transcript interface.
 */
export function instanceOfTranscript(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TranscriptFromJSON(json: any): Transcript {
    return TranscriptFromJSONTyped(json, false);
}

export function TranscriptFromJSONTyped(json: any, ignoreDiscriminator: boolean): Transcript {
    return json;
}

export function TranscriptToJSON(value?: Transcript | null): any {
    return value;
}

